import React, { useState } from 'react';
import { Router } from '@reach/router';
import { TeamsList } from './TeamsList';
import { TeamEdit } from './TeamEdit';
import { TableComponents } from '@kineticdata/bundle-common';

const tableKey = 'teams-list';

export const Teams = ({ match }) => {
  const [pageSize, setPageSize] = useState(25);
  return (
    <Router>
      <TableComponents.MountWrapper tableKey={tableKey} default>
        <TeamEdit tableKey={tableKey} path=":slug" />
        <TeamsList
          tableKey={tableKey}
          pageSize={pageSize}
          setPageSize={setPageSize}
          default
        />
      </TableComponents.MountWrapper>
    </Router>
  );
};
